/** $12.34 for values >= 1, up to 4 dp for sub-dollar values (e.g. $0.0042). */
export function fmtUsd(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  const abs = Math.abs(value);
  const maxDp = abs > 0 && abs < 1 ? 4 : 2;
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: maxDp })}`;
}

/** Token counts: thousands separators, collapsing to 1.2M style for large values. */
export function fmtTokens(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  if (Math.abs(value) >= 1_000_000) {
    return `${(value / 1_000_000).toLocaleString('en-US', { maximumFractionDigits: 1 })}M`;
  }
  return value.toLocaleString('en-US');
}

export function fmtNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return value.toLocaleString('en-US');
}

/** YYYY-MM-DD from a Date (UTC). */
export function isoDate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

/** YYYY-MM-DD for n days before today. */
export function daysAgo(n: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - n);
  return isoDate(d);
}

/** Render an ISO timestamp (or date) as YYYY-MM-DD; em dash when missing. */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return iso.slice(0, 10);
}

const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Render an ISO timestamp as "HH:mm dd MMM" in local time (e.g. "14:07 22 Jul"). */
export function fmtTimestamp(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getHours())}:${pad(d.getMinutes())} ${pad(d.getDate())} ${monthsShort[d.getMonth()]}`;
}
